export function parseTimeCode( timeCode, fps = 30 ) {
	let value = -1;
	const matches = timeCode.match( /^([\d.]+):([\d.]+):([\d.]+)(?:;(\d+))?$/ );

	if ( ! matches ) {
		return value;
	}

	let [
		_,
		hours,
		minutes,
		seconds,
		frames,
	] = matches;

	value = 0;
	hours = parseFloat( hours );
	minutes = parseFloat( minutes );
	seconds = parseFloat( seconds );
	frames = parseFloat( frames );

	if ( hours > 0 ) {
		value += hours * 60 * 60;
	}

	if ( minutes > 0 ) {
		value += minutes * 60;
	}

	if ( seconds > 0 ) {
		value += seconds;
	}

	if ( frames > 0 && frames < fps ) {
		value += frames / fps;
	}

	return value;
}

export function formatTimeCode( timeCode ) {
	let tc = timeCode;

	if ( tc.includes( '.' ) ) {
		tc = tc.substring( 0, tc.indexOf( '.' ) );
	}

	const parts = tc
		.split( ':' )
		.map( part => parseInt( part, 10 ) )
		.filter( val => val > 0 );
	tc = parts.join( ':' );

	if ( parts.length === 1 ) {
		tc = `:${ tc }`;
	}

	return tc;
}

export function debounce( fn, time = 100 ) {
	let timer = null;

	const cancel = () => {
		clearTimeout( timer );
		timer = null;
	};

	function debouncedFn( ...args ) {
		cancel();

		timer = setTimeout( () => {
			fn( ...args );
		}, time );
	}

	debouncedFn.cancel = cancel;

	return debouncedFn;
}
